import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";

//Prime React Components
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { Toast } from "primereact/toast";

//Custom Validation
import { LoginValidate } from "../../config/Validate";
//Buffer Storage
import { Buffer } from "buffer";

//API Constant Settings
import { LOGIN } from "../../config/ApiConstant";
import axiosInstance from "../../config/axiosInstance";
import { getRedirectPath } from "../../config/redirectHelper";
import { Link } from "react-router-dom";

interface finalObj {
  email: string;
  password: string;
}

export const Login = () => {
  document.title = "Login | Nexawage Payroll";

  const urlParams = new URLSearchParams(window.location.search);
  const verified = urlParams.get("verified");

  const [loginData, setLoginData] = useState<any>({});
  const [errors, setErrors] = useState<any>({});
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const toast = useRef<any>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  let pay_cycle_id = userData?.pay_cycle_id;

  useEffect(() => {
    if (verified) {
      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: "Your account has been verified successfully, Please Login.",
      });
    }
  }, [verified]);

  // handle Change
  const _onHandleChange = (e: any, name: string) => {
    const val = (e.target && e.target.value).trim() || "";
    setLoginData({ ...loginData, [name]: val });
    setErrors({ ...errors, [name]: "" });
  };

  //on submit button event
  const onSubmit = async (e: any) => {
    try {
      const { errors, isError } = LoginValidate(loginData);
      setErrors(errors);

      if (!isError) {
        setButtonLoading(true);

        const email = loginData.email;
        //Password base64 convert
        let passwordBuff = Buffer.from(loginData.password).toString("base64");

        //Create Request Data Object
        const Obj: finalObj = {
          email: email,
          password: passwordBuff,
        };

        //API Call
        const response = await axiosInstance.post(LOGIN, Obj);

        //Get API Response

        if (response) {
          // get Data for localstorage
          const { token, user_data } = response.data;

          const usertoken = token;

          //After Success Login Set Token in Common
          axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + usertoken;

          //set localstorage
          localStorage.setItem("token", usertoken);
          localStorage.setItem("user_data", JSON.stringify(user_data));
          localStorage.setItem("pay_cycle_id", JSON.stringify(user_data?.pay_cycle_id));

          // set status for bank detail model to display in dashboard
          localStorage.setItem("payment_model_status", "false");

          toast.current?.show({
            severity: "success",
            summary: "Success",
            detail: response?.data?.message,
          });

          // setTimeout(() => {
          //   const role = user_data?.roles?.role_name;

          //   // If client log in with report redirect link
          //   let redirectPath = redirectByRole(role);

          //   if (role === "Client") {
          //     const rawRedirect = queryParams.get("redirect");
          //     if (rawRedirect?.startsWith("/report")) {
          //       const parts = rawRedirect.split("/");
          //       const clientIdEncoded = parts[4];
          //       const clientId = atob(clientIdEncoded);
          //       const loggedInUserId = user_data?.id;

          //       if (clientId == loggedInUserId) {
          //         redirectPath = rawRedirect;
          //       }
          //     }
          //   }

          //   navigate(redirectPath);
          // }, 500);

          setTimeout(() => {
            const role = user_data?.roles?.role_name;

            // redirect based on loged in user and if userrole is client and url is resport/run-payroll then redirect to runpayroll page
            const redirectPath = getRedirectPath({
              role,
              userId: user_data?.id,
              search: window.location.search,
            });

            navigate(redirectPath);
          }, 500);
        } else {
          return;
        }
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Alert",
        detail: error?.response?.data?.message,
      });
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="login-body">
        <div className="login-panel p-fluid">
          <div className="w-full">
            <div className="flex gap-2 mb-4 justify-content-center align-items-center logo-container">
              <img src="\assets\images\Nexawage_new_logo.png" className="login-logo" style={{ width: "80px", height: "80px" }} alt="login-logo" />
              <h2 className="m-0" style={{ color: "#41486b" }}>
                Nexawage Payroll
              </h2>
            </div>

            <div className="mt-3">
              <div className="login-form form-container">
                <div className="field">
                  <span className=" p-input-icon-left">
                    <i className="pi pi-envelope"></i>
                    <InputText
                      autoComplete="off"
                      value={!window.cn(loginData.email) ? loginData?.email : ""}
                      type="text"
                      placeholder="Email"
                      onChange={(e) => _onHandleChange(e, "email")}
                      className={errors["email"] && "p-invalid"}
                    />
                  </span>
                  {errors["email"] && <small className="p-invalid-txt d-flex">{errors["email"]}</small>}
                </div>
                <div className="field">
                  <span className="p-input-icon-left">
                    <i className="pi pi-key"></i>
                    <Password
                      value={!window.cn(loginData.password) ? loginData?.password : ""}
                      name="password"
                      placeholder="Password"
                      onChange={(e) => _onHandleChange(e, "password")}
                      toggleMask
                      feedback={false}
                      autoComplete="current-password"
                      className={errors["password"] && "p-invalid"}
                    />
                  </span>
                  {errors["password"] && <small className="p-invalid-txt d-flex">{errors["password"]}</small>}
                </div>
              </div>

              <div className="login-btn button-container">
                <Button type="button" label="Login" loading={buttonLoading} onClick={onSubmit}></Button>
              </div>

              <div className="flex justify-content-center home-page-navigation">
                <Link to="/" className="home-page-navigation flex align-items-center gap-2">
                  <i className="pi pi-home" style={{ color: "#44486D" }}></i>
                  <span>Go To Home</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
